import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Select,
  OutlinedInput,
  Box,
  Chip,
  InputLabel,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Link,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
} from "@mui/material";
import FlexBox from "components/FlexBox";
import useTitle from "hooks/useTitle";
import LoadingScreen from "components/LoadingScreen";
import useAuth from "hooks/useAuth";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { alpha } from '@mui/material/styles';
import UkoAvatar from "components/UkoAvatar";
import { Add, Delete, PhotoCamera } from "@mui/icons-material";

const Form = () => {
  const [routDefaultLabel, setRoutDefaultLabel] = useState("");
  const [item, setItem] = useState(null);
  const [inputs, setInputs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const [stateUpdate, setStateUpdate] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const { axios, user } = useAuth();
  const { id, routeDefault, view } = useParams(); // Recupera o ID da rota
  const location = useLocation();
  const [type, setType] = useState("edit");
  let navigate = useNavigate();

  const setupInputs = () => {
    switch (routeDefault) {
      case "appointments":
        setRoutDefaultLabel("Evento");
        return [
          {
            name: "name",
            label: "Nome do Cliente",
            type: "input",
            disabled: true,
          },
          {
            name: "phone",
            label: "WhatsApp",
            type: "input",
            disabled: true,
          },
          {
            name: "date",
            label: "Data",
            type: "input",
            disabled: true,
          },
          {
            name: "price",
            label: "Preço",
            type: "input",
            disabled: true,
          },
          {
            name: "service_id",
            label: "Serviço",
            type: "select_unique",
            options: [],
            searchTerm: "services",
          },
          {
            name: "user_id",
            label: "Profissional",
            type: "select_unique",
            options: [],
            searchTerm: "users",
          },
          {
            label: "Chamar no WhatsApp",
            type: "button-whatsapp",
            variant: "contained",
            color: "primary",
            typeButton: "button",
            context: "edit",
          },
          {
            label: "Cancelar Agendamento",
            type: "button-cancel-appointment",
            variant: "contained",
            color: "error",
            typeButton: "button",
            context: "edit",
          }
        ];
      case "services":
        setRoutDefaultLabel("Serviço");
        return [
          {
            type: "image",
            routeDefault: "service",
          },
          {
            name: "name",
            label: "Nome",
            type: "input",
          },
          {
            name: "price",
            label: "Preço R$",
            type: "input",
          },
          {
            name: "active",
            label: "Ativo",
            type: "checkbox",
          },
          {
            name: "show_price",
            label: "Exibir valor no agendamento",
            type: "checkbox",
          },
          {
            name: "user_ids",
            label: "Profissionais",
            type: "select",
            options: [],
            searchTerm: "users",
          },
          {
            name: "duration",
            label: "Tempo de atendimento (minutos)",
            type: "input",
            required: true
          },
          {
            name: "duration_days",
            label: "Antecedência para agendamento (dias)",
            type: "input",
          },
          {
            name: "mon",
            label: "Segunda-feira",
            type: "checkbox",
          },
          {
            name: "initial_mon",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_mon",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "tue",
            label: "Terça-feira",
            type: "checkbox",
          },
          {
            name: "initial_tue",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_tue",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "wed",
            label: "Quarta-feira",
            type: "checkbox",
          },
          {
            name: "initial_wed",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_wed",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "thu",
            label: "Quinta-feira",
            type: "checkbox",
          },
          {
            name: "initial_thu",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_thu",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "fri",
            label: "Sexta-feira",
            type: "checkbox",
          },
          {
            name: "initial_fri",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_fri",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "sat",
            label: "Sábado",
            type: "checkbox",
          },
          {
            name: "initial_sat",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_sat",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "sun",
            label: "Domingo",
            type: "checkbox",
          },
          {
            name: "initial_sun",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_sun",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "initial_interval",
            label: "Horário de início da pausa (almoço)",
            type: "input",
          },
          {
            name: "interval",
            label: "Duração da pausa (horas)",
            type: "input",
            isHours: true,
          },
          {
            label: "Períodos com preço personalizado",
            type: "overtime_periods",
          },
          // {
          //   name: "delivery_interval_enabled",
          //   label: "Habilitar limite após o primeiro agendamento",
          //   type: "checkbox",
          // },
          // {
          //   name: "delivery_interval_minutes",
          //   label: "Tempo limite após o primeiro agendamento (em horas)",
          //   type: "input",
          //   isHours: true,
          // },
          {
            label: "Salvar",
            type: "button",
            variant: "contained",
            color: "primary",
            typeButton: "submit",
            context: "create/edit",
          }
        ];
      case "configs":
        setRoutDefaultLabel("Configurção de horário do Serviço");
        return [
          {
            name: "service_name",
            label: "Serviço",
            type: "input",
            disabled: true,
          },
          {
            name: "duration",
            label: "Duração do serviço (em horas)",
            type: "input",
            isHours: true,
          },
         
          {
            name: "duration_days",
            label: "Quantos dias fica aberto a agenda (em dias)",
            type: "input",
          },
          {
            name: "mon",
            label: "Segunda-feira",
            type: "checkbox",
          },
          {
            name: "initial_mon",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_mon",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "tue",
            label: "Terça-feira",
            type: "checkbox",
          },
          {
            name: "initial_tue",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_tue",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "wed",
            label: "Quarta-feira",
            type: "checkbox",
          },
          {
            name: "initial_wed",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_wed",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "thu",
            label: "Quinta-feira",
            type: "checkbox",
          },
          {
            name: "initial_thu",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_thu",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "fri",
            label: "Sexta-feira",
            type: "checkbox",
          },
          {
            name: "initial_fri",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_fri",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "sat",
            label: "Sábado",
            type: "checkbox",
          },
          {
            name: "initial_sat",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_sat",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "sun",
            label: "Domingo",
            type: "checkbox",
          },
          {
            name: "initial_sun",
            label: "Horário de início (0-23)",
            type: "input",
          },
          {
            name: "final_sun",
            label: "Horário de fim (0-23)",
            type: "input",
          },
          {
            name: "delivery_interval_enabled",
            label: "Habilitar restrição de intervalo",
            type: "checkbox",
          },
          {
            name: "delivery_interval_minutes",
            label: "Tempo limite após o primeiro agendamento (em horas)",
            type: "input",
            isHours: true,
          },
          {
            name: "initial_interval",
            label: "Início da pausa (almoço, pausa)",
            type: "input",
          },
          {
            name: "interval",
            label: "Duração da pausa (almoço, pausa)",
            type: "input",
            isHours: true,
          },
          
        ];
      case "users":
        setRoutDefaultLabel("Funcionário");
        return [
          {
            type: "image",
            routeDefault: "user",
          },
          {
            name: "name",
            label: "Nome",
            type: "input",
          },
          {
            name: "email",
            label: "Email",
            type: "input",
          },
          {
            name: "phone",
            label: "Celular (XX) 99999-9999",
            type: "input",
          },
          {
            name: "password",
            label: "Senha",
            type: "input",
          },
          {
            name: "active",
            label: "Ativo",
            type: "checkbox",
            defaultValue: true,
            context: "edit",
          },
          {
            name: "service_ids",
            label: "Serviços",
            type: "select",
            options: [],
            searchTerm: "services",
          },
          {
            label: "Salvar",
            type: "button",
            variant: "contained",
            color: "primary",
            typeButton: "submit",
            context: "create/edit",
          }
        ];
    }
  };


  const setupTitle = () => {
    switch (type) {
      case "edit":
        return `Editar`;
      case "view":
        return `Visualizar`;
      default:
        return `Adicionar`;
    }
  };
  const routeConfig = () => {
    switch (type) {
      case "edit":
        return `Editar ${routDefaultLabel}`;
      case "view":
        return `Visualizar ${routDefaultLabel}`;
      default:
        return `Adicionar ${routDefaultLabel}`;
    }
  };

  useTitle(setupTitle);

  const handleChange = (e, labelName, inputType = "select") => {
    const { name, value, checked, type } = e.target;

    if (inputType == "select_unique") {
      setItem({ ...item, [labelName]: value });
      return;
    }

    if (type === "checkbox") {
      setItem({ ...item, [labelName]: checked });
      return;
    }
    
    // Verificar se o campo é de horas
    const input = inputs.find(input => input.name === (name || labelName));
    if (input && input.isHours) {
      if (value !== "" && !isNaN(parseFloat(value))) {
        // Para campos de horas, aceitar apenas valores inteiros
        const intValue = Math.floor(parseFloat(value));
        if (name) {
          setItem({ ...item, [name]: intValue.toString() });
        } else {
          setItem({
            ...item,
            optionsValues: item.optionsValues
              ? item.optionsValues.find((i) => i.name === labelName)
                ? item.optionsValues.map((options) => {
                    if (options.name === labelName) {
                      return { name: labelName, value: intValue.toString() };
                    }
                    return options;
                  })
                : [...item.optionsValues, { name: labelName, value: intValue.toString() }]
              : [],
          });
        }
      } else {
        // Se o campo está vazio ou inválido, limpar o valor
        if (name) {
          setItem({ ...item, [name]: "" });
        } else {
          setItem({
            ...item,
            optionsValues: item.optionsValues
              ? item.optionsValues.find((i) => i.name === labelName)
                ? item.optionsValues.map((options) => {
                    if (options.name === labelName) {
                      return { name: labelName, value: "" };
                    }
                    return options;
                  })
                : [...item.optionsValues, { name: labelName, value: "" }]
              : [],
          });
        }
      }
      return;
    }
    
    if (name) {
      setItem({ ...item, [name]: value });
    } else {
      setItem({
        ...item,
        optionsValues: item.optionsValues
          ? item.optionsValues.find((i) => i.name === labelName)
            ? item.optionsValues.map((options) => {
                if (options.name === labelName) {
                  return { name: labelName, value: value };
                }
                return options;
              })
            : [...item.optionsValues, { name: labelName, value: value }]
          : [],
      });
    }
  };

  const processPayload = () => {
    const payload = { ...item, company_id: user.company_id };

    if (routeDefault === "services") {
      payload.service_off_hours_attributes = (item.service_off_hours || [])
        .filter((period) => period._destroy || (period.weekday !== "" && period.start_time && period.end_time && period.price !== ""))
        .map(({ id, weekday, start_time, end_time, price, _destroy }) => ({
          id,
          weekday: Number(weekday),
          start_time,
          end_time,
          price: Number(price),
          _destroy,
        }));
    }
    
    // Converter APENAS campos de horas para minutos antes do envio
    inputs.forEach((input) => {
      if (input.isHours && input.type === "input" && payload[input.name] !== null && payload[input.name] !== undefined && payload[input.name] !== "") {
        const hoursValue = parseInt(payload[input.name]);
        if (!isNaN(hoursValue)) {
          payload[input.name] = hoursValue * 60;
        }
      }
    });
    
    if (item.optionsValues) {
      item.optionsValues.forEach((i) => {
        payload[i.name] = i.value;
      });
    }

    return payload;
  };

  const handleImageFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setImageFile(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validações obrigatórias específicas por rota
    if (routeDefault === "services") {
      const durationVal = item?.duration;
      const isValidDuration = durationVal !== undefined && durationVal !== null && String(durationVal).trim() !== "" && !isNaN(Number(durationVal)) && Number(durationVal) > 0;
      if (!isValidDuration) {
        toast.error("Informe a duração do serviço (minutos)");
        setLoading(false);
        return;
      }
      if (!item?.initial_interval) {
        toast.error("Informe o início da pausa de almoço, caso não tenha intervalo coloque zero na duração da pausa");
        setLoading(false);
        return;
      }
      
      if(!item?.initial_mon || !item?.final_mon || !item?.initial_tue || !item?.final_tue || !item?.initial_wed || !item?.final_wed || !item?.initial_thu || !item?.final_thu || !item?.initial_fri || !item?.final_fri || !item?.initial_sat || !item?.final_sat || !item?.initial_sun || !item?.final_sun) {
        toast.error("Informe todos os horários de início e fim da semana");
        setLoading(false);
        return;
      }

      if(!item?.interval) {
        toast.error("Informe a duração da pausa de almoço");
        setLoading(false);
        return;
      }
    }

    if (id && Number.isInteger(parseInt(id))) {
      try {
        // Enviar dados principais como JSON
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/companies/${user.company_id}/${routeDefault}/${id}`,
          {
            [routeDefault.slice(0, -1)]: {
              ...processPayload(),
            },
          }
        );

        // Enviar imagem separadamente se foi selecionada
        if (imageFile) {
          const imageFormData = new FormData();
          imageFormData.append(`${routeDefault.slice(0, -1)}[img]`, imageFile);
          await axios.put(
            `${process.env.REACT_APP_API_URL}/companies/${user.company_id}/${routeDefault}/${id}`,
            imageFormData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          );
        }

        toast.success("Atualizado com sucesso!");
        setImageFile(null); // Limpar arquivo selecionado
        let prev = null;
        if (routeDefault === "configs") {
          prev = `services`;
        }
        navigate(`/dashboard/${prev || routeDefault}`);
      } catch (error) {
        if(typeof error === "string") {
          toast.error(error);
        }
      } finally {
        setLoading(false);
      }
    } else {
      try {
        // Enviar dados principais como JSON
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/companies/${user.company_id}/${routeDefault}`,
          {
            [routeDefault.slice(0, -1)]: {
              ...processPayload(),
            },
          }
        );

        // Enviar imagem separadamente se foi selecionada
        if (imageFile) {
          const imageFormData = new FormData();
          imageFormData.append(`${routeDefault.slice(0, -1)}[img]`, imageFile);
          await axios.put(
            `${process.env.REACT_APP_API_URL}/companies/${user.company_id}/${routeDefault}/${response.data.id}`,
            imageFormData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          );
        }

        toast.success("Adicionado com sucesso!");
        setImageFile(null); // Limpar arquivo selecionado
        navigate(`/dashboard/${routeDefault}`);
      } catch (error) {
        if(typeof error === "string") {
          toast.error(error);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const show = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/companies/${user.company_id}/${routeDefault}/${id}`
      );
      
      // Converter campos de minutos para horas na exibição
      const convertedData = { ...response.data };
      inputs.forEach((input) => {
        if (input.isHours && convertedData[input.name] !== null && convertedData[input.name] !== undefined && convertedData[input.name] !== "") {
          const minutesValue = parseFloat(convertedData[input.name]);
          if (!isNaN(minutesValue)) {
            convertedData[input.name] = Math.round(minutesValue / 60).toString();
          }
        }
        // Inicializar checkboxes como false se vierem undefined/null
        if (input.type === "checkbox" && (convertedData[input.name] === undefined || convertedData[input.name] === null)) {
          convertedData[input.name] = false;
        }
        // Garantir que img_url exista
        if (input.type === "image" && !convertedData["img_url"]) {
          convertedData["img_url"] = "";
        }
      });
      
      setItem({
        ...convertedData,
        optionsValues: inputs
          .filter((input) => input.type === "select")
          .map((input) => {
            return { name: input.name, value: convertedData[input.name] };
          }),
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const listOptions = async (input) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/companies/${user.company_id}/${input.searchTerm}`
      );
      setInputs(
        inputs.map((i) => {
          if (i.name === input.name) {
            return {
              ...i,
              options: response.data.map((item) => {
                return { label: item.name, value: item.id };
              }),
            };
          }
          return i;
        })
      );
    } catch (error) {
    } finally {
      setLoading(false);
      setStateUpdate(true);
    }
  };

  const searchOptionList = () => {
    inputs.forEach((input) => {
      if ("select" === input.type || "select_unique" === input.type) {
        if (type === "create") {
          setItem({ ...item, optionsValues: [] });
        } else {
          setItem({ ...item });
        }
        listOptions(input);
      }
    });
  };

  // Função para buscar todas as opções dos selects
  const fetchAllOptions = async (inputsList) => {
    const updatedInputs = await Promise.all(
      inputsList.map(async (input) => {
        if ((input.type === "select" || input.type === "select_unique") && input.searchTerm) {
          try {
            const response = await axios.get(
              `${process.env.REACT_APP_API_URL}/companies/${user.company_id}/${input.searchTerm}`
            );
            return {
              ...input,
              options: response.data.map((item) => ({ label: item.name, value: item.id })),
            };
          } catch {
            return input;
          }
        }
        return input;
      })
    );
    return updatedInputs;
  };

  // Função para buscar o item (dados do formulário)
  const fetchItem = async (inputsList) => {
    if (id && Number.isInteger(parseInt(id))) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/companies/${user.company_id}/${routeDefault}/${id}`
        );
        // Converter campos de minutos para horas na exibição
        const convertedData = { ...response.data };
        inputsList.forEach((input) => {
          if (input.isHours && convertedData[input.name] !== null && convertedData[input.name] !== undefined && convertedData[input.name] !== "") {
            const minutesValue = parseFloat(convertedData[input.name]);
            if (!isNaN(minutesValue)) {
              convertedData[input.name] = Math.round(minutesValue / 60).toString();
            }
          }
          // Inicializar checkboxes como false se vierem undefined/null
          if (input.type === "checkbox" && (convertedData[input.name] === undefined || convertedData[input.name] === null)) {
            convertedData[input.name] = false;
          }
          // Garantir que img_url exista
          if (input.type === "image" && !convertedData["img_url"]) {
            convertedData["img_url"] = "";
          }
        });
        return {
          ...convertedData,
          optionsValues: inputsList
            .filter((input) => input.type === "select")
            .map((input) => {
              return { name: input.name, value: convertedData[input.name] };
            }),
        };
      } catch {
        return null;
      }
    } else {
      // Adicionar: inicializar todos os campos do item
      const emptyItem = {};
      inputsList.forEach((input) => {
        if (input.type === "checkbox") {
          emptyItem[input.name] = input.defaultValue !== undefined ? input.defaultValue : false;
        } else if (input.type === "select" || input.type === "select_unique") {
          emptyItem[input.name] = input.multiple ? [] : "";
        } else if (input.type === "image") {
          emptyItem["img_url"] = "";
        } else {
          emptyItem[input.name] = "";
        }
      });

      // Valores padrão específicos para serviços
      if (routeDefault === "services") {
        emptyItem.price = "0";
        emptyItem.off_hours_price = "";
        emptyItem.duration = "";
        emptyItem.duration_days = "30"; // 30 dias de antecedência
        emptyItem.active = true;
        emptyItem.show_price = true;
        emptyItem.delivery_interval_enabled = false;
        emptyItem.delivery_interval_minutes = "2"; // 2 horas
        emptyItem.interval = "1"; // 1 hora de pausa
        
        // Horários padrão de trabalho (Segunda a Sexta)
        emptyItem.mon = true;
        emptyItem.tue = true;
        emptyItem.wed = true;
        emptyItem.thu = true;
        emptyItem.fri = true;
        emptyItem.sat = false;
        emptyItem.sun = false;
        
        // Horários padrão (8h às 18h)
        emptyItem.initial_mon = "08";
        emptyItem.final_mon = "18";
        emptyItem.initial_tue = "08";
        emptyItem.final_tue = "18";
        emptyItem.initial_wed = "08";
        emptyItem.final_wed = "18";
        emptyItem.initial_thu = "08";
        emptyItem.final_thu = "18";
        emptyItem.initial_fri = "08";
        emptyItem.final_fri = "18";
        emptyItem.initial_sat = "08";
        emptyItem.final_sat = "18";
        emptyItem.initial_sun = "08";
        emptyItem.final_sun = "18";
        
        // Pausa padrão (12h às 13h)
        emptyItem.initial_interval = "12";
        emptyItem.service_off_hours = [];
      }

      // Para selects múltiplos, inicializar optionsValues
      emptyItem.optionsValues = inputsList
        .filter((input) => input.type === "select")
        .map((input) => ({ name: input.name, value: [] }));
      return emptyItem;
    }
  };

  // Função central para carregar tudo
  const loadAllData = async () => {
    setLoading(true);
    setReady(false);
    setItem(null);
    // 1. Monta os inputs iniciais
    let baseInputs = setupInputs();
    // 2. Busca as opções dos selects
    const inputsWithOptions = await fetchAllOptions(baseInputs);
    setInputs(inputsWithOptions);
    // 3. Busca o item (se for edição/view)
    const loadedItem = await fetchItem(inputsWithOptions);
    setItem(loadedItem);
    setLoading(false);
    setReady(true);
  };

  // Efeito para recarregar tudo quando location.key mudar
  useEffect(() => {
    // Atualiza tipo
    if (id && Number.isInteger(parseInt(id))) {
      if (view) {
        setType("view");
      } else {
        setType("edit");
      }
    } else {
      setType("create");
    }
    loadAllData();
  }, [location.key]);

  // Atualiza campo de data se vier na URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setItem((prev) => prev ? { ...prev, date: searchParams.get("date") } : prev);
  }, [location.search]);


  if (loading || !ready || (id && Number.isInteger(parseInt(id)) && !item)) {
    return <LoadingScreen />;
  }

  const actionTypes = ["button", "button-cancel-appointment", "button-whatsapp"];
  const fieldInputs = inputs.filter((i) => !actionTypes.includes(i.type));
  const actionInputs = inputs.filter((i) => actionTypes.includes(i.type));

  const weekdayOptions = [
    [0, "Domingo"], [1, "Segunda-feira"], [2, "Terça-feira"], [3, "Quarta-feira"],
    [4, "Quinta-feira"], [5, "Sexta-feira"], [6, "Sábado"],
  ];

  const updatePeriod = (index, field, value) => {
    setItem((current) => ({
      ...current,
      service_off_hours: (current.service_off_hours || []).map((period, periodIndex) =>
        periodIndex === index ? { ...period, [field]: value } : period
      ),
    }));
  };

  const addPeriod = () => {
    setItem((current) => ({
      ...current,
      service_off_hours: [
        ...(current.service_off_hours || []),
        { weekday: 1, start_time: "", end_time: "", price: "" },
      ],
    }));
  };

  const removePeriod = (index) => {
    setItem((current) => ({
      ...current,
      service_off_hours: (current.service_off_hours || []).flatMap((period, periodIndex) => {
        if (periodIndex !== index) return [period];
        return period.id ? [{ ...period, _destroy: true }] : [];
      }),
    }));
  };

  const renderActionButton = (input) => {
    const isVisible =
      input.context === "create/edit" ||
      (input.context === "create" && type === "create") ||
      (input.context === "edit" && type === "edit");

    if (!isVisible) return null;

    if (input.type === "button-cancel-appointment") {
      return (
        <Button
          key={input.label}
          variant={input.variant}
          color={input.color}
          sx={{ color: "white", minHeight: 48, flex: { xs: 1, sm: "0 0 auto" } }}
          type="button"
          onClick={async () => {
            try {
              await axios.put(
                `${process.env.REACT_APP_API_URL}/appointments/cancel/${item.uuid}`,
                {}
              );
              toast.success("Cancelado com sucesso!");
              navigate(`/dashboard/${routeDefault}`);
            } catch (error) {
            } finally {
              setLoading(false);
            }
          }}
        >
          {input.label}
        </Button>
      );
    }

    if (input.type === "button-whatsapp") {
      return (
        <Button
          key={input.label}
          variant={input.variant}
          color="success"
          sx={{ color: "white", minHeight: 48, flex: { xs: 1, sm: "0 0 auto" } }}
          type="button"
          onClick={() => window.open(`https://wa.me/${item.phone}`, "_blank")}
        >
          {input.label}
        </Button>
      );
    }

    return (
      <Button
        key={input.label}
        variant={input.variant}
        color={input.color}
        sx={{ minHeight: 48, flex: { xs: 1, sm: "0 0 auto" } }}
        type="submit"
        form="main-form"
        disabled={loading}
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : input.label}
      </Button>
    );
  };

  return (
    <Box sx={{ pb: { xs: 9, sm: 10 } }}>
      <Card
        elevation={0}
        sx={{
          borderRadius: 2,
          background: (theme) => alpha(theme.palette.background.paper, 0.8),
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: (theme) => `0 8px 24px ${alpha(theme.palette.common.black, 0.1)}`,
          }
        }}
      >
        <CardContent>
          <form id="main-form" onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {fieldInputs.length > 0 && item && item[fieldInputs[0]?.name] !== null && fieldInputs.map((input) => {
                switch (input.type) {
                  case "overtime_periods":
                    return (
                      <Box key={input.type} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <Typography variant="subtitle1">{input.label}</Typography>
                        {(item.service_off_hours || []).map((period, index) => !period._destroy && (
                          <Box key={period.id || index} sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
                            <TextField
                              select
                              label="Dia"
                              value={period.weekday ?? ""}
                              onChange={(event) => updatePeriod(index, "weekday", event.target.value)}
                              sx={{ minWidth: 170 }}
                            >
                              {weekdayOptions.map(([value, label]) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
                            </TextField>
                            <TextField
                              type="time"
                              label="Início"
                              value={period.start_time || ""}
                              onChange={(event) => updatePeriod(index, "start_time", event.target.value)}
                              inputProps={{ step: 60 }}
                            />
                            <TextField
                              type="time"
                              label="Fim"
                              value={period.end_time || ""}
                              onChange={(event) => updatePeriod(index, "end_time", event.target.value)}
                              inputProps={{ step: 60 }}
                            />
                            <TextField
                              type="number"
                              label="Preço (R$)"
                              value={period.price ?? ""}
                              onChange={(event) => updatePeriod(index, "price", event.target.value)}
                              inputProps={{ min: 0, step: "0.01" }}
                            />
                            <IconButton aria-label="Remover período" onClick={() => removePeriod(index)}>
                              <Delete />
                            </IconButton>
                          </Box>
                        ))}
                        <Button type="button" startIcon={<Add />} onClick={addPeriod} sx={{ alignSelf: "flex-start" }}>
                          Adicionar período
                        </Button>
                      </Box>
                    );
                  case "image":
                    return (
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <Box position="relative">
                          <UkoAvatar
                            src={imageFile ? URL.createObjectURL(imageFile) : `${process.env.REACT_APP_API_URL}${item?.img_url}`}
                            sx={{
                              border: 4,
                              width: 120,
                              height: 120,
                              borderColor: "background.paper",
                            }}
                          />
                          <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="image-upload"
                            type="file"
                            onChange={handleImageFileChange}
                          />
                          <label htmlFor="image-upload">
                            <IconButton
                              component="span"
                              sx={{
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                backgroundColor: 'primary.main',
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: 'primary.dark',
                                }
                              }}
                            >
                              <PhotoCamera />
                            </IconButton>
                          </label>
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                          Clique no ícone da câmera para alterar a imagem
                        </Typography>
                      </Box>
                    );
                  case "input":
                    return (
                      <TextField
                        label={input.label}
                        variant="outlined"
                        id={input.name}
                        name={input.name}
                        value={item[input.name] || ""}
                        onChange={(e) => handleChange(e, input.name)}
                        required={input.required}
                        sx={{ 
                          maxWidth: "500px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
                              borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                              borderColor: (theme) => theme.palette.primary.main,
                              borderWidth: "2px",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: (theme) => theme.palette.primary.main,
                              borderWidth: "2px",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            color: (theme) => alpha(theme.palette.text.primary, 0.7),
                            "&.Mui-focused": {
                              color: (theme) => theme.palette.primary.main,
                              fontWeight: "bold",
                            },
                          },
                          "& .MuiInputBase-input": {
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => alpha(theme.palette.text.secondary, 0.8),
                              opacity: 1,
                            },
                          },
                        }}
                        margin="normal"
                        placeholder={input.label}
                        disabled={type !== "create" && (input.disabled || false)}
                        type={input.isHours ? "number" : "text"}
                        inputProps={input.isHours ? { step: "1", min: "0" } : {}}
                      />
                    );
                  case "text":
                    return (
                      <TextField
                        label={input.label}
                        variant="outlined"
                        id={input.name}
                        name={input.name}
                        value={item[input.name] || ""}
                        onChange={(e) => handleChange(e, input.name)}
                        sx={{ 
                          maxWidth: "500px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: (theme) => alpha(theme.palette.grey[400], 0.5),
                              borderWidth: "2px",
                            },
                            "&.Mui-disabled fieldset": {
                              borderColor: (theme) => alpha(theme.palette.grey[400], 0.3),
                            },
                          },
                          "& .MuiInputLabel-root": {
                            color: (theme) => alpha(theme.palette.text.primary, 0.6),
                            "&.Mui-disabled": {
                              color: (theme) => alpha(theme.palette.text.disabled, 0.8),
                            },
                          },
                          "& .MuiInputBase-input": {
                            color: (theme) => alpha(theme.palette.text.primary, 0.8),
                            "&.Mui-disabled": {
                              color: (theme) => alpha(theme.palette.text.disabled, 0.9),
                              WebkitTextFillColor: (theme) => alpha(theme.palette.text.disabled, 0.9),
                            },
                            "&::placeholder": {
                              color: (theme) => alpha(theme.palette.text.secondary, 0.6),
                              opacity: 1,
                            },
                          },
                        }}
                        margin="normal"
                        placeholder={input.label}
                        disabled={true}
                      />
                    );
                  case "number":
                    return (
                      <TextField
                        label={input.label}
                        variant="outlined"
                        type="number"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        id={input.name}
                        name={input.name}
                        value={parseFloat(item[input.name]) || ""}
                        onChange={(e) => handleChange(e, input.name)}
                        sx={{ 
                          maxWidth: "500px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
                              borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                              borderColor: (theme) => theme.palette.primary.main,
                              borderWidth: "2px",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: (theme) => theme.palette.primary.main,
                              borderWidth: "2px",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            color: (theme) => alpha(theme.palette.text.primary, 0.7),
                            "&.Mui-focused": {
                              color: (theme) => theme.palette.primary.main,
                              fontWeight: "bold",
                            },
                          },
                          "& .MuiInputBase-input": {
                            color: (theme) => theme.palette.text.primary,
                            "&::placeholder": {
                              color: (theme) => alpha(theme.palette.text.secondary, 0.8),
                              opacity: 1,
                            },
                          },
                        }}
                        margin="normal"
                        placeholder={input.label}
                        disabled={type !== "create" && (input.disabled || false)}
                      />
                    );
                  case "link_config_id": {
                    return type === "edit" && 
                       (<Link
                        sx={{ mt: 3 }}
                        href={`/dashboard/configs/${item[input.name]}`}
                      >
                        {input.label}
                      </Link>)
                    
                    
                  }
                  case "checkbox":
                    return (
                      item[input.name] !== null ? 
                      <FormControlLabel
                        control={
                          <Checkbox
                            id={input.name}
                            checked={!!item[input.name]}
                            onChange={(e) => handleChange(e, input.name)}
                            color="primary"
                          />
                        }
                        label={input.label}
                      /> : null
                    );
                  case "select":
                    return (
                      <div>
                        <InputLabel id="demo-mutiple-checkbox-label">
                          {input.label}
                        </InputLabel>
                        <Select
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
                                borderWidth: "2px",
                              },
                              "&:hover fieldset": {
                                borderColor: (theme) => theme.palette.primary.main,
                                borderWidth: "2px",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: (theme) => theme.palette.primary.main,
                                borderWidth: "2px",
                              },
                            },
                          }}
                          labelId="demo-mutiple-checkbox-label"
                          id={input.name}
                          multiple
                          displayEmpty
                          value={
                            item.optionsValues?.find(
                              (option) => option.name === input.name
                            )?.value || []
                          }
                          input={
                            <OutlinedInput
                              id="select-multiple-chip"
                              label="Chip"
                            />
                          }
                          onChange={(e) => handleChange(e, input.name)}
                          renderValue={(selected) => (
                            <Box
                              sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                            >
                              {selected.length === 0 ? (
                                <span style={{ color: '#999', fontStyle: 'italic' }}>
                                  Selecione {input.label.toLowerCase()}...
                                </span>
                              ) : (
                                selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={
                                      input.options.find(
                                        (item) => item.value === value
                                      )?.label
                                    }
                                    style={{
                                      fontWeight: "bold",
                                    }}
                                  />
                                ))
                              )}
                            </Box>
                          )}
                        >
                          {input.options &&
                            input.options.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                        </Select>
                      </div>
                    );
                  case "select_unique":
                    return (
                      <div>
                        <InputLabel id="demo-mutiple-checkbox-label">
                          {input.label}
                        </InputLabel>
                        <Select
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
                                borderWidth: "2px",
                              },
                              "&:hover fieldset": {
                                borderColor: (theme) => theme.palette.primary.main,
                                borderWidth: "2px",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: (theme) => theme.palette.primary.main,
                                borderWidth: "2px",
                              },
                            },
                          }}
                          labelId="demo-mutiple-checkbox-label"
                          id={input.name}
                          displayEmpty
                          value={item[input.name] ? [item[input.name]] : []}
                          input={
                            <OutlinedInput
                              id="select-multiple-chip"
                              label="Chip"
                            />
                          }
                          onChange={(e) =>
                            handleChange(e, input.name, "select_unique")
                          }
                          renderValue={(selected) => (
                            <Box
                              sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                            >
                              {selected.length === 0 ? (
                                <span style={{ color: '#999', fontStyle: 'italic' }}>
                                  Selecione {input.label.toLowerCase()}...
                                </span>
                              ) : (
                                selected.map((value) => (
                                  <Chip
                                    key={value}
                                    label={
                                      input.options.find(
                                        (item) => item.value === value
                                      )?.label
                                    }
                                    style={{
                                      fontWeight: "bold",
                                    }}
                                  />
                                ))
                              )}
                            </Box>
                          )}
                        >
                          {input.options &&
                            input.options.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                        </Select>
                      </div>
                    );
                }
              })}
            </Box>
          </form>
        </CardContent>
      </Card>

      {actionInputs.length > 0 && (
        <Box
          sx={{
            position: 'sticky',
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: 'background.paper',
            borderTop: '1px solid',
            borderColor: 'divider',
            boxShadow: '0 -2px 12px rgba(0,0,0,0.08)',
            p: { xs: 1.5, sm: 2 },
            zIndex: 10,
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          {actionInputs.map((input) => renderActionButton(input))}
        </Box>
      )}
    </Box>
  );
};

export default Form;
